import React from 'react';

import clsxm from '@/lib/clsxm';

export type ContentProps = React.PropsWithChildren<{
  className?: string;
  centered?: boolean;
  type?: 'body' | 'header';
}>;

const Content: React.FC<ContentProps> = ({
  className,
  centered = true,
  children,
  type,
}) => {
  return (
    <div
      className={clsxm(
        'w-[312px]',
        type === 'header' && 'webS:w-[688px] webM:w-[1136px]',
        type === 'body' && 'webS:w-[512px] webM:w-[944px]',
        centered && 'mx-auto',
        className
      )}
    >
      {children}
    </div>
  );
};

export default Content;
